import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';

dayjs.extend(utcPlugin);

export const ONBOARDING_STEP = {
  SELECT_TEMPLETE: 'selectTemplete',
  SELECT_DATE: 'selectDate',
  ADD_TRIP: 'addTrip',
  SELECT_RECOMMEND_TRIP_DATE: 'selectRecommendTripDate',
};

export const TITLE = {
  [ONBOARDING_STEP.SELECT_TEMPLETE]: 'Select an itinerary template',
  [ONBOARDING_STEP.SELECT_DATE]: 'Start date',
  [ONBOARDING_STEP.SELECT_RECOMMEND_TRIP_DATE]: 'Start date',
  [ONBOARDING_STEP.ADD_TRIP]: 'A new trip',
};
